import {Text} from '@mantine/core';
import {Dropzone, MIME_TYPES} from '@mantine/dropzone';
import React from 'react';
import {FiUploadCloud} from 'react-icons/fi';
import {NestedKeys} from 'shared/types/key-manipulation';
import {BaseInputProps} from '../..';

import ImagePreview from './components/image-preview';

import {Container, DropzoneContent, DropzoneWrapper, Label} from './styles';
import {useController, useFormContext} from 'react-hook-form';
import {FileProps} from 'shared/types/file';
import {UseMutationResult} from 'react-query';

export interface ImagePickerProps<T = any> extends BaseInputProps {
  name: NestedKeys<T>;
  index?: number;
  label: string;
  multiple?: boolean;
  onRemove?: () => UseMutationResult<any, unknown, T, unknown>;
}

const ImagePicker: React.FC<ImagePickerProps> = ({
  name,
  label,
  multiple = false,
  onRemove,
}) => {
  const {control} = useFormContext();
  const {field} = useController({name, control});

  const handleDrop = (files: File[]) => {
    if (multiple) return field.onChange([...(field.value ?? []), ...files]);
    return field.onChange(files[0]);
  };

  const removeImage = (imageIndex: number) => {
    field.onChange(
      (field.value as (File | FileProps)[]).filter(
        (image, index) => index !== imageIndex,
      ),
    );
  };

  return (
    <Container>
      <Label>{label}</Label>
      <DropzoneWrapper>
        {!multiple && field.value && (
          <ImagePreview
            {...{
              image: field.value,
              removeImage: onRemove,
              onRemove: () => field.onChange(null),
            }}
          />
        )}
        {multiple &&
          (field.value as (File | FileProps)[])?.map((image, index: number) => (
            <ImagePreview
              key={String(index)}
              {...{
                image,
                onRemove: () => removeImage(index),
                removeImage: onRemove,
              }}
            />
          ))}
        {(multiple || !field.value) && (
          <Dropzone
            onDrop={handleDrop}
            accept={[MIME_TYPES.jpeg, MIME_TYPES.png, MIME_TYPES.webp]}
            multiple={multiple}>
            <DropzoneContent>
              <FiUploadCloud size={28} />
              <Text>Adicione as imagens</Text>
            </DropzoneContent>
          </Dropzone>
        )}
      </DropzoneWrapper>
    </Container>
  );
};

export default ImagePicker;
